<template>
    <div id="templatePane">
        <div class="hero-section shade-40">
            <div class="hero-section-text row column">
                <h1>Setup Workplace on a BT Webtop PC</h1>
            </div>
        </div>
        <section id="mainContent" class="row column">
            <p>To setup Workplace on a BT Webtop PC, follow these steps:</p>
            <ol>
                <li>Open a web browser, visit <a target="_blank" href="http://bt.workplace.com">http://bt.workplace.com</a> or <a target="_blank" href="http://openreach.workplace.com">http://openreach.workplace.com</a>.
                <p><img src="/static/images/help/25921_1.png" alt="" /></p></li>
                <li>Click <strong>Log in</strong>.
                <p><img src="/static/images/help/25921_2.png" alt="" /></p></li>
                <li>You'll be prompted to pick an account, select your <strong>work email account</strong>.
                <p><img src="/static/images/help/25921_7.png" alt="" /></p></li>
                <li>On your first sign-in you'll see your name already populated, click <strong>Create Account</strong>.
                <p><img src="/static/images/help/25921_8.png" alt="" /></p></li>
                <li>Workplace is now setup and you're ready to go.
                <p><img src="/static/images/help/25921_6.png" alt="" /></p></li>
            </ol>
            <p>Need more help?  Browse our <a href="/help">list of articles.</a></p>
        </section>
    </div>
</template>
<script>
    export default {
    name: 'Help25921'
}
</script>